<template>
  <div>
    <Header />
    <div class="other-contents">
      <div @click="openModal">
        <img src="@/assets/other/アセット 10@2x.png" class="account-information" width="2100" height="360" loding="lazy" />
      </div>
      <div v-if="hearingsAlert">
        <img @click="openDialog" src="@/assets/other/アセット 11@2x.png" class="health-check" v-bind:class="{ zindex: isTutorial }" width="2100" height="360" loding="lazy" />
      </div>
      <div v-else>
        <router-link to="frailtyRiskCheck">
          <img src="@/assets/other/アセット 11@2x.png" class="health-check" v-bind:class="{ zindex: isTutorial }" width="2100" height="360" loding="lazy" />
        </router-link>
      </div>
      <div @click="openModal">
        <img src="@/assets/other/アセット 12@2x.png" class="healthcare-services" width="2100" height="360" loding="lazy" />
      </div>
      <router-link to="/top">
        <img src="@/assets/other/アセット 13@2x.png" class="logout" width="2100" height="360" loding="lazy" />
      </router-link>
      <div></div>
    </div>
    <Footer />
    <Tutorial v-if="isTutorial" />
    <ShowDialog v-show="isDialog" @handle-hide-dialog="hideDialog" />
    <ShowContent v-if="isShowContent" @handle-hide-content="closeModal" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Tutorial from "@/components/Tutorial";
import ShowDialog from "@/components/ShowDialog";
import ShowContent from "@/components/ShowContent";
import moment from "moment";

export default {
  name: "Other",
  components: {
    Footer,
    Header,
    Tutorial,
    ShowDialog,
    ShowContent,
  },
  data() {
    return {
      isTutorial: false,
      isDialog: false,
      isShowContent: false,
      hearingsAlert: false,
    };
  },
  beforeDestroy() {
    document.body.className = "";
  },
  mounted() {
    document.body.className = "back-color";
    if (this.$store.state.isTutorial) this.isTutorial = true;

    this.hearingsLatestDateYear = this.$store.state.hearingsLatestDate.split("-")[0];
    this.hearingsLatestDateMonth = this.$store.state.hearingsLatestDate.split("-")[1];

    if (this.hearingsLatestDateYear === moment().format("YYYY") && this.hearingsLatestDateMonth === moment().format("MM")) {
      this.hearingsAlert = true;
    } else {
      this.hearingsAlert = false;
    }
  },
  methods: {
    hideDialog() {
      this.isDialog = false;
    },
    openDialog() {
      this.isDialog = true;
    },
    openModal() {
      this.isShowContent = true;
    },
    closeModal() {
      this.isShowContent = false;
    },
  },
};
</script>

<style scoped>
.other-contents {
  padding: 3%;
  position: relative;
  height: 60vh;
}

.other-contents img {
  width: 95%;
  left: 2.5%;
  position: absolute;
}
.account-information {
  top: 6%;
}

.health-check {
  top: 23%;
  z-index: 4;
}
.zindex {
  z-index: 4;
}

.healthcare-services {
  top: 40%;
}

.logout {
  top: 105%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Other.vue